import { createFileRoute } from "@tanstack/react-router"
import { CreateApiToken } from "modules/settings/components/KeysAndSecrets/CreateApiToken"

export const Route = createFileRoute("/_base/_auth/settings/keys-and-secrets/api-tokens/create")({
  component: CreateApiToken,
})
